import {
    CoachableMetric,
    CommitmentFocusSummaryDto,
    CommitmentFocusSummarySetDto,
    FocusDto,
} from '../../coaching-base/general';
import { CommitmentGoalMetric } from '../../coaching-base/general/commitment-goal-metric.model';
import {
    Column,
    Row,
    Sort,
    SortOrder,
} from '../../coaching-observation/experimental.grid';
import { BehaviourItem } from '../models/behaviour.coaching.model';
import { SubBehaviourItem } from '../models/subbehaviour.coaching.model';

import {
    CellContext,
    ColumnID,
    RowContext,
    TagItemCategories,
    TagSelection,
} from './tags.model';

export interface TagSetState {
    pending: {
        init?: boolean;
    };

    /** stored here to check for a change in performers */
    performerId?: number;

    focusSummarySet?: CommitmentFocusSummarySetDto;
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    activeMetricId?: number;

    tags?: CommitmentFocusSummaryDto[];
    teamTags?: CommitmentFocusSummaryDto[];
    tagItemCategories: TagItemCategories;
    selected?: FocusDto;
    coachableMetrics?: CoachableMetric[];

    selection?: TagSelection;
    selectionBehaviourStr?: string;
    selectionMetricsStr?: string;

    filterText: string;
    filteredBehaviours?: BehaviourItem[];
    filteredSubBehaviours?: SubBehaviourItem[];
    filterMetricText?: string;

    cache?: CommitmentFocusSummaryDto[];

    gridColumns?: Column[]; // this is special. it should not be recreated else the entire grid would be invalidated
    gridRowsTop?: Array<Row<RowContext, CellContext>>;
    gridRows?: Array<Row<RowContext, CellContext>>;
    gridSortDefs?: Sort[];

    activeUserCommitmentFocuses?: CommitmentGoalMetric[];
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const defaultSortDef = () => ({
    columnId: ColumnID.OA_OPPORTUNITY,
    order: SortOrder.ASC,
});

export const defaultState = (): TagSetState => ({
    pending: {},
    tagItemCategories: {
        active: {},
        closed: {},
        team: {},
    },
    filterText: '',
    filterMetricText: '',
    gridSortDefs: [
        { columnId: ColumnID.OA, order: SortOrder.ASC },
        defaultSortDef(),
    ],
});
